import React from 'react';
import s from '../../PersonalOffice/CreateInvoice/CreateInvoice.module.css';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

const BackToOffice: React.FC = () => {
	const {t} = useTranslation();
	const navigate = useNavigate();
	return (
		<div className={s.topRevertTitle}>
			<button className={s.backArrow} onClick={() => navigate(-1)}>
				{t('Назад в офіс')} <span> </span>
			</button>
		</div>
	);
};

export default BackToOffice;
